module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"section.note":"บันทึกของ Lot นี้","section.drone.registered":"สถิติ Drone ที่ลงทะเบียนเรียบร้อย","section.ticket.stat":"สถิติ Ticket ของ Drone Lot นี้","section.ticket.progress":"Ticket ที่อยู่ระหว่างดำเนินการ"}}')
  delete Component.options._Ctor
}
